import React, { Component } from 'react';
import styles from './index.module.less';

export default class Text extends Component {

  render() {
    return (
      <a className={styles.textBox}>
        <h1>互联网与车企深度融合，创造数字化未来</h1>
        {/* <p>完整的基础体系</p>
        <p>多种行业定制方案</p>
        <p>智能安全防护架构</p>
        <p>高效的大数据分析和处理能力</p> */}
        <ul>
          <li>完整的云计算基础体系</li>
          <li >多种行业定制解决方案</li>
          <li>智能云安全防护架构</li>
          <li>高效的大数据分析和处理能力</li>
          <li>人工智能向全局智能持续演进</li>
        </ul>
      </a>
    )
  }
}
